<template>
  <div class="modal-dialog modal-lg" role="document">
    <img src="static/img/PB-by-luna.png" id="luna-logo" />
    <div class="modal-content">
      <div class="mb-5"></div>
      <div class="modal-body">
        <div class="col-12" id="subcontainer">
          <div v-if="this.loading" id="div-loading">
            <img id="loading-gif" src="static/img/pix.gif" />
          </div>
          <div v-else-if="this.pix_senha" class="height-300">
            <PixPassword
              :callApi="this.callApi"
              :pix_senha_invalida="this.pix_senha_invalida"
            />
          </div>
          <div v-else-if="!this.pix_disponivel" class="height-300">
            <p>Pix vencido ou indisponível!</p>
          </div>
          <PixCopy
            v-else
            :pix_emv="this.pix_emv"
            :ced_inscricao="this.ced_inscricao"
            :cedente:="this.cedente"
            :sac_inscricao="this.sac_inscricao"
            :sacado="this.sacado"
            :num_docto="this.num_docto"
            :nosso_numero="this.nosso_numero"
            :cod_dt_vencto="this.cod_dt_vencto"
            :pix_valor="this.pix_valor"
            :pix_base64="this.pix_base64"
            :pix_dt_vencto="this.pix_dt_vencto"
            :pix_disponivel="this.pix_disponivel"
            :pix_hour_expiration="this.pix_hour_expiration"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import PixCopy from "./PixCopy.vue";
import PixPassword from "./PixPassword.vue";

export default {
  name: "PixView",
  components: {
    PixCopy,
    PixPassword,
  },
  data() {
    return {
      pix_emv: "",
      ced_inscricao: "",
      cedente: "",
      sac_inscricao: "",
      sacado: "",
      num_docto: "",
      nosso_numero: "",
      cod_dt_vencto: null,
      pix_valor: 0,
      pix_base64: "",
      pix_dt_vencto: null,
      pix_disponivel: false,
      loading: true,
      pix_senha: false,
      pix_hour_expiration: "23:59",
      password: "",
      pix_senha_invalida: false,
    };
  },
  methods: {
    updatePassword(password) {
      this.password = password;
    },
    callApi(password) {
      const token = this.$route.query.token;

      if (!token) {
        this.loading = false;
        return;
      }

      const http = axios.create();

      return http
        .post(`${process.env.API_PBM}/pixCopy?token=${token}`, { password })
        .then((response) => {
          this.pix_emv = response.data.data.pix_emv;
          this.ced_inscricao = response.data.data.ced_inscricao;
          this.cedente = response.data.data.cedente;
          this.sac_inscricao = response.data.data.sac_inscricao;
          this.sacado = response.data.data.sacado;
          this.num_docto = response.data.data.num_docto;
          this.nosso_numero = response.data.data.nosso_numero;
          this.cod_dt_vencto = response.data.data.cod_dt_vencto;
          this.pix_valor = response.data.data.pix_valor;
          this.pix_base64 = response.data.data.pix_base64;
          this.pix_dt_vencto = response.data.data.pix_dt_vencto;
          this.pix_hour_expiration = response.data.data.pix_hour_expiration;

          this.pix_senha = false;
          this.pix_disponivel = true;
          this.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 403) {
            this.pix_senha = true;
            if (password) {
              this.pix_senha_invalida = true;
            }
          }
          this.pix_disponivel = false;
          this.loading = false;
          throw err;
        });
    },
  },
  mounted() {
    this.callApi();
  },
};
</script>
<style scoped>
body {
  overflow-x: hidden;
}

.height-300 {
  height: 300px;
}

#loading-gif {
  position: absolute;
  top: -25px;
  right: -5px;
  width: 384px;
  height: 263px;
}

#div-loading {
  position: relative;
  width: 400px;
  height: 300px;
}

#subcontainer {
  display: flex;
  justify-content: center;
}

.modal-body {
  padding: 1rem 1rem 1rem 0rem;
}

#luna-logo {
  position: fixed;
  width: 424;
  height: 50px;
  top: 0;
  right: 10px;
}

@media only screen and (max-width: 767px) {
  .modal-content {
    width: 100%;
    margin-left: -0px;
    opacity: 0.9;
  }
  .modal-dialog {
    margin-top: 90%;
  }

  #loading-gif {
    position: absolute;
    top: 10px;
    right: -10px;
    width: 324px;
    height: 213px;
  }
}

@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
  .modal-dialog {
    margin-top: 7%;
  }
}

@media only screen and (min-width: 2000px) {
  .modal-dialog {
    margin-top: 12%;
  }
  /* for sumo sized (mac) screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/pix/PixView.vue